import type { PaginatedResultOfGetUserTaskResponse } from "@/openapi/generated";
import { filterManualUserTasks } from "@/lib/user-tasks/is-manual-user-task";
import { isUserTaskActive } from "@/lib/user-tasks/user-task-status-display";

function toTotalCount(
  data: PaginatedResultOfGetUserTaskResponse | undefined,
): number {
  const raw = data?.totalCount;
  return typeof raw === "number" ? raw : Number(raw ?? 0);
}

/** Active-task count from a paginated user-tasks response (`active=true` when API supports it). */
export function countActiveUserTasksFromPage(
  data: PaginatedResultOfGetUserTaskResponse | undefined,
): number {
  if (!data) return 0;

  const items = data.items ?? [];
  const activeOnPage = items.filter((task) =>
    isUserTaskActive(task.status),
  ).length;

  if (items.length === 0) {
    return toTotalCount(data);
  }

  const apiTotal = toTotalCount(data);

  if (data.hasNextPage && items.every((task) => isUserTaskActive(task.status))) {
    return apiTotal;
  }

  if (!data.hasNextPage) {
    return activeOnPage;
  }

  return activeOnPage;
}

/**
 * Sidebar / Tasks page badge: Open + In progress, studio-created only.
 * System enrollment/makeup tasks stay on dashboard widgets, not this count.
 */
export function countActiveManualUserTasksFromPage(
  data: PaginatedResultOfGetUserTaskResponse | undefined,
): number {
  if (!data) return 0;
  const manual = filterManualUserTasks(data.items ?? []);
  if (manual.length === 0) return 0;
  return manual.filter((task) => isUserTaskActive(task.status)).length;
}
